'use client';

export interface ServiceAllCapsTitleProps {
  className?: string;
  title: string;
  /** When true, title wraps on mobile and stays one line from tablet up */
  wrapOnMobile?: boolean;
}

export function ServiceAllCapsTitle({ title, className, wrapOnMobile }: ServiceAllCapsTitleProps) {
  return (
    <h3
      className={`font-breit text-[24px] font-kraftig uppercase leading-normal text-at ${
        wrapOnMobile ? 'whitespace-normal tablet:whitespace-nowrap' : 'whitespace-nowrap'
      } ${className ?? ''}`}
    >
      {title}
    </h3>
  );
}
